import { create } from 'zustand';
import { ApiUtils, ApplicationApi, AssignApplicationRequest, RequestStrategyEnum } from '@shared/api';

interface IAssignApplicationStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  assignApplication: (request: AssignApplicationRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAssignApplicationStore = create<IAssignApplicationStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  assignApplication: ApiUtils.wrapperApi(async (request: AssignApplicationRequest, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await ApplicationApi.assignApplication(request, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
